import { render, staticRenderFns } from "./ProjetoGestaoDetalhamento.vue?vue&type=template&id=5f8677b5&"
import script from "./ProjetoGestaoDetalhamento.vue?vue&type=script&lang=js&"
export * from "./ProjetoGestaoDetalhamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports